import Constants from '../Constants';
const { SIDEBAR_TOGGLE } = Constants;

export const toggleSidebar = (state) => ({ type: SIDEBAR_TOGGLE, payload: state });


// WEBPACK FOOTER //
// ./src/Actions/LayoutActions.js